import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderRow } from './order-row.model';

/**
 * What the body hands back when it closes. The column owns the patient-app handoff, so the sheet
 * reports intent rather than calling PampIframeService itself — that keeps one implementation of
 * "open this order" instead of a second copy living in the sheet.
 */
export type OrderDetailAction = 'openInPatientApp' | 'edit';

@Component({
  selector: 'csi-order-detail-sheet',
  templateUrl: './order-detail-sheet.component.html',
  styleUrls: ['./order-detail-sheet.component.scss']
})
export class OrderDetailSheetComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public orderRow: OrderRow,
    private sheetReference: MatDialogRef<OrderDetailSheetComponent, OrderDetailAction>
  ) {}

  public close(): void {
    this.sheetReference.close();
  }

  public openInPatientApp(): void {
    this.sheetReference.close('openInPatientApp');
  }

  public editOrder(): void {
    this.sheetReference.close('edit');
  }

  public trackByProductName(index: number, productName: string): string {
    return productName;
  }
}
